export enum SidebarSettings {
    UTILIZATORI = 'Utilizatori',
    INSTITUTII = 'Instituții / Direcții',
    COMPARTIMENTE = 'Departamente / Birouri / Servicii',
    // DEPARTAMENTE = 'Departamente',
    // CONFIGURATII = 'Configurări',
    FUNCTII = 'Funcții',
    // CERERE_SABLOANE = 'Șabloane Cereri',
    PLATFORM_SECTION = 'Secțiuni Platformă',
    PLATFORM_FAQ = 'FAQ Platformă',
    PLATFORM_CONTENT = 'Conținut Platformă',
    PLATFORM_ANNOUNCES = 'Anunțuri Platformă',
    CERERE_TYPES = 'Tipuri Cerere',
    CERERE_STATUS = 'Status Cerere',
    CERERE_PRIORITY = 'Prioritate Cerere',
    TIPURI_DOCUMENTE = 'Tipuri Documente',
    TARI = 'Țări',
    JUDETE = 'Județe',
    LOCALITATI = 'Localități',
    STRAZI = 'Străzi'
}

export enum AdminSettingsSidebar {
    CONFIGURARI = 'Configurări',
    TYPE_IMAGE = 'Dimensiuni Tip Imagini',
    MODULE = 'Module',
    MODULE_GROUP_PERMISSION = 'Grup Module/App',
    MODULE_PERMISSION = 'Permisiuni - module',
    CONFIGURATOR_MODULE = 'Configurator - module',
    TYPE_USER = 'Tip Utilizator',
    SOURCE = 'Surse',
    CRONS = 'Cron-uri',
    SOLICITARE_RANK = 'Solicitare Rank',
    // PERMISSION_ACTION = 'Permisiuni Acțiuni',
    // SECTIONS = 'Secțiuni',
    // PERMISSION = 'Permisiuni',
}

export enum BulevartSettingsSidebar {
    CATEGORII = 'Categorii',
    SUBCATEGORII = 'Subcategorii',
    CATEGORII_TERTIARE = 'Categorii Terțiare',
}

export enum GhiseulUnicSettingsSidebar {
    STATUS = 'Statusuri',
    PRIORITY = 'Priorități',
    TIPURI_PROGRAM_ACTIVE = 'Disponibilitate Programări',
    MODULE = 'Module',
    LOCATII = 'Locații',
    SERVICII = 'Servicii',
    MODULE_LOCATII_ACTIVE = 'Module Locații Active',
    LOCATII_SERVICII_ACTIVE = 'Locații Servicii Active',
    MODULE_LOCATII_SERVICII_ACTIVE = 'Module Locații Servicii Active',
    PROGRAMARI_SLOTURI_BLOCARE = 'Programări Sloturi Blocare',
    PROGRAMARI_SLOTURI_ULTIMA_ORA = 'Programări Sloturi Borderou',
    TIPURI_PROGRAM = 'Tipuri Program',
    TIPURI_PROBLEMA = 'Tipuri Problemă',
    OPERATORI = 'Operatori',
    TIPURI_PROBLEMA_SERVICII_ACTIVE = 'Tipuri Problemă Servicii Active',
    ZILE_LIBERE = 'Zile Libere',
}

export enum InstitutiiSettingsSidebar {
    ANI = 'Ani',
    CATEGORII_DOCUMENTE = 'Categorii Documente',
    TIPURI_DOCUMENTE = 'Tipuri Documente',
    SECTIUNI_PUBLICE = 'Secțiuni Publice',
}
